import { Fetcher } from '@Types/fetcher'
import useBaseFetcher from '../base'

function useCountryList(): Fetcher {
  const [baseFetcher, meta] = useBaseFetcher(true)

  const countryFetcher = async () => {
    return await baseFetcher(
      `${import.meta.env.VITE_APP_URL}/onboarding/currencies-and-countries`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
  }

  return [countryFetcher, meta]
}

export default useCountryList
